import React from 'react';
import { FaFire } from 'react-icons/fa';

function formatCount(value) {
  return Number(value || 0).toLocaleString('en-IN');
}

function PropertyStatsRollup({
  stats,
  compact = false,
  onInventoryClick,
  onDemandClick,
}) {
  if (!stats) {
    return null;
  }

  const clickable = Boolean(onInventoryClick || onDemandClick);

  return (
    <div className={`re-stats-rollup${compact ? ' re-stats-rollup--compact' : ''}`}>
      {!compact && (
        <div className='re-stats-rollup__kpis'>
          <div className='re-stats-rollup__kpi'>
            <span className='re-stats-rollup__kpi-value'>{formatCount(stats.totalUnits)}</span>
            <span className='re-stats-rollup__kpi-label'>Units</span>
          </div>
          <div className='re-stats-rollup__kpi'>
            <span className='re-stats-rollup__kpi-value'>{stats.occupancyPct}%</span>
            <span className='re-stats-rollup__kpi-label'>Occupied</span>
          </div>
          <div className='re-stats-rollup__kpi'>
            <span className='re-stats-rollup__kpi-value'>{formatCount(stats.activeLeads)}</span>
            <span className='re-stats-rollup__kpi-label'>Active leads</span>
          </div>
        </div>
      )}

      <div className={`re-stats-rollup__columns${compact ? ' re-stats-rollup__columns--compact' : ' re-portfolio__columns'}`}>
        <section className={`re-stats-rollup__section${compact ? '' : ' re-portfolio__section'}`}>
          <h4 className='re-stats-rollup__section-title'>Inventory status</h4>
          <div className='re-inventory-bars'>
            {(stats.inventory || []).map(row => {
              const Tag = clickable && row.count > 0 && onInventoryClick ? 'button' : 'div';
              return (
                <Tag
                  key={row.key}
                  type={Tag === 'button' ? 'button' : undefined}
                  className={`re-inventory-bar${clickable && row.count > 0 ? ' re-inventory-bar--clickable' : ''}`}
                  onClick={
                    clickable && row.count > 0 && onInventoryClick
                      ? () => onInventoryClick(row.drillDown)
                      : undefined
                  }
                >
                  <span className='re-inventory-bar__label'>{row.label}</span>
                  <div className='re-inventory-bar__track'>
                    <div
                      className='re-inventory-bar__fill'
                      style={{
                        width: `${row.count === 0 ? 2 : row.percent}%`,
                        backgroundColor: row.color,
                      }}
                    />
                  </div>
                  <span className='re-inventory-bar__count'>{formatCount(row.count)}</span>
                </Tag>
              );
            })}
          </div>
        </section>

        <section className={`re-stats-rollup__section${compact ? '' : ' re-portfolio__section'}`}>
          <h4 className='re-stats-rollup__section-title'>Lead demand</h4>
          {!compact && (
            <p className='re-portfolio__section-hint'>Available units by open interest count</p>
          )}
          <ul className='re-demand-list'>
            {(stats.demand || []).map(row => (
              <li key={row.tier}>
                <button
                  type='button'
                  className={`re-demand-list__item re-demand-list__item--${row.tier}${row.count > 0 && onDemandClick ? ' re-demand-list__item--clickable' : ''}`}
                  disabled={!onDemandClick || row.count === 0}
                  onClick={() => onDemandClick?.(row.drillDown)}
                >
                  <span className='re-demand-list__label'>
                    {row.tier === 'high' && (
                      <FaFire className='re-demand-list__icon' aria-hidden='true' />
                    )}
                    {row.label}
                  </span>
                  <span className='re-demand-list__value'>
                    {formatCount(row.count)} unit{row.count === 1 ? '' : 's'}
                    {row.suffix && ` ${row.suffix}`}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}

export default PropertyStatsRollup;
